import { Outlet } from 'react-router-dom';

// Pages
import CreateTicketPage from 'src/pages/ticketCreation/CreateTicketPage';
import TooManyRequestsPage from 'src/pages/ticketCreation/TooManyRequestsPage';

import FormUnavailable from '../pages/ticketCreation/FormUnavailable';
import FormSharableSubmitted from '../pages/ticketCreation/FormSharableSubmitted';

const CommonRoutes = {
  path: '*',
  element: <Outlet />,
  children: [
    {
      path: 'create-ticket',
      element: <CreateTicketPage />,
    },
    {
      path: 'form-sharable-submitted',
      element: <FormSharableSubmitted />,
    },
    {
      path: 'form-unavailable',
      element: <FormUnavailable />,
    },
    {
      path: 'too-many-requests',
      element: <TooManyRequestsPage />,
    },
  ],
};

export default CommonRoutes;
